export default "__VITE_ASSET__4c8cd973__"